export const firebaseConfig = {
  apiKey: 'AIzaSyD8vCmAAjriBBy8wLZkqfH2X1528dHFKqw',
  authDomain: 'classic-driver-1470107239288.firebaseapp.com',
  databaseURL: 'https://classic-driver-1470107239288.firebaseio.com',
  projectId: 'classic-driver-1470107239288',
  storageBucket: 'classic-driver-1470107239288.appspot.com',
  messagingSenderId: '401458716447'
};
